import inssMetadata from './data/metadata.json';
import type { InssDataVersion } from './types.js';

export const INSS_DATA_VERSION: InssDataVersion = inssMetadata as InssDataVersion;
